'use client';

import React from 'react';
import { TasticProps } from 'frontastic/tastics/types';
import WhyCaromaBanner,{WhyCaromaBannerProps} from 'components/commercetools-ui/organisms/content/why-caroma-banner';

const WhyCaromaBannerTastic = ({ data }: TasticProps<WhyCaromaBannerProps>) => {
  return <WhyCaromaBanner data={data?.data?.dataSource} />;
};

export default WhyCaromaBannerTastic;